/* eslint-disable react/require-default-props */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { InlineDate } from '@ui/molecules/inputs';`
 * Or: `import { InlineDate } from '@ui/molecules/inputs/inline';`
 *
 * Or specific path: `import { InlineEdit } from '@ui/molecules/inputs/InlineEdit';`
 *
 * See the new component for documentation and migration notes.
 */
import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import { DatePicker } from '@progress/kendo-react-dateinputs';
export function InlineEditDate(_a) {
    var { as, children, className, disableEdit = false, placeholder = '--', label, id, 'aria-labelledby': ariaLabelledby, dateValue, onDateChange } = _a, props = __rest(_a, ["as", "children", "className", "disableEdit", "placeholder", "label", "id", 'aria-labelledby', "dateValue", "onDateChange"]);
    const Component = as || 'div';
    const variantClass = 'qmb-inedit--date';
    const [isOpen, setIsOpen] = useState(false);
    const handleClick = () => {
        if (!disableEdit) {
            setIsOpen(true);
        }
    };
    const handleDateChange = (e) => {
        setIsOpen(false);
        if (onDateChange && e.value instanceof Date) {
            // Convert local date to UTC to avoid timezone issues
            const date = new Date(e.value.getFullYear(), e.value.getMonth(), e.value.getDate(), 0, 0, 0, 0);
            onDateChange(date);
        }
    };
    const CustomInput = useCallback((inputProps) => {
        const inputDateValue = inputProps.value;
        const formattedDate = inputDateValue instanceof Date && !Number.isNaN(inputDateValue.getTime())
            ? `${(inputDateValue.getMonth() + 1).toString().padStart(2, '0')}/${inputDateValue
                .getDate()
                .toString()
                .padStart(2, '0')}/${inputDateValue.getFullYear()}`
            : children || placeholder;
        return (React.createElement(Component, Object.assign({ className: classNames(variantClass, className), onClick: handleClick, "data-placeholder": placeholder, "data-label": label, id: id, disabled: disableEdit, "aria-labelledby": ariaLabelledby }, props), formattedDate));
    }, [children, placeholder, label, variantClass, className, disableEdit, handleClick, props, id, ariaLabelledby]);
    return (React.createElement("div", null,
        React.createElement(DatePicker, { value: dateValue instanceof Date && !Number.isNaN(dateValue.getTime())
                ? new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate())
                : null, onChange: handleDateChange, show: isOpen, onBlur: () => setIsOpen(false), dateInput: CustomInput, toggleButton: () => null })));
}
